import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import ApiCalls from "../../../apis/api-calls";
import "../../../../assets/css/components/Profile/BillingComponent/AddNewCard/AddNewCardComponent.css";
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CardForm = inject("sharedStore")(observer((props) => {
  const { sharedStore, closeModalHandler, showPopup } = props
  const [cardholderName, setCardHolderName] = useState("")
  const [nameError, setNameError] = useState("")
  const [stripeError, setStripeError] = useState("")
  const [disableButton, setDisable] = useState(false)
  const stripe = useStripe();
  const elements = useElements();

  const onInputChange = (e) => {
    setCardHolderName(e.target.value)
  };

  const isValidName = () => {
    let regName = /^[a-zA-Z ]*$/;
    let regex = /^.*\w.*\s.*\w.*$/;
    if (!cardholderName) {
      setNameError("Name cannot be empty")
      return false;
    } else if (regName.test(cardholderName) === false) {
      setNameError("Only Alphabets are allowed")
      return false;
    } else if (regex.test(cardholderName) === false) {
      setNameError("Please enter full name")
      return false;
    } else {
      setNameError("")
      return true;
    }
  };

  const fetchCard = () => {
    sharedStore.showLoader();
    ApiCalls.fetchCard()
      .then((cardObj) => {
        sharedStore.hideLoader();
        if (cardObj && cardObj.error === false) {
          if (cardObj.data) {
            sharedStore.setPaymentData(cardObj.data);
          } else {
            sharedStore.clearPaymentData();
          }
        }
      })
      .catch((err) => console.log("err", err));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardNumberElement),
    });
    if (paymentMethod && isValidName()) {
      setDisable(true)
      let data = {
        payment_method: paymentMethod.id,
        card_holder: cardholderName,
        default: false,
      };
      sharedStore.showLoader();
      ApiCalls.attchPaymentMethod(data)
        .then((response) => {
          sharedStore.hideLoader();
          if (response && response.error === false) {
            closeModalHandler();
            fetchCard();
          } else {
            closeModalHandler();
            showPopup(3, response.message);
          }
        })
        .catch((err) => {
          sharedStore.hideLoader();
          console.log("err", err);
        });
    }

    if (error) {
      isValidName()
      setStripeError(error.message)
    }

  };


  return (
    <form id="card" onSubmit={handleSubmit}>
      <div className="field-wrapper">
        <div className={"form-group"}>
          <label htmlFor="fName">Name on Card</label>
          <input
            type="label"
            maxLength="100"
            id="chName"
            autoComplete="off"
            className="form-control card-control"
            name="cardholderName"
            value={cardholderName}
            placeholder="i.e. John Doe"
            onChange={onInputChange}
          />
          <div className="error-text">{nameError}</div>
        </div>
        <div
          className={"form-group"}
        >
          <div className="card_inputs custom_cardnumber">
            <label>Card number </label>
            <CardNumberElement className="form-control stripe-control" />
          </div>
          <div className="card_inputs custom_monthnumber">
            <label>Month </label>
            <CardExpiryElement className="form-control stripe-control" />
          </div>
          <div className="card_inputs custom_cvcnumber">
            <label>CVC </label>
            <CardCvcElement className="form-control stripe-control" />
          </div>
        </div>
        <div className="error-text">{stripeError}</div>
        <div className="text-center">
          <button
            id="card-button"
            data-secret={"zzz"}
            type="submit"
            className="btn btn-common"
            disabled={disableButton}
          >
            Save Card
        </button>
        </div>
      </div>
    </form>
  )
}))

export default (CardForm)


// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/AddNewCard/CardForm.jsx